import React, { useContext, useEffect, useState,useCallback } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { Text } from 'rebass'
import { ExternalLink } from '../../theme'
import { useActiveWeb3React } from '../../hooks'
import { CONTRACT_ADDRESSES } from '../../constants/api'

import useBidList from '../../hooks/nft/useBidList'

const Box = styled.div`
  padding: 24px;
  width: 500px;
  background: ${({ theme}) => theme.bsBg41};
  box-shadow: ${({ theme}) => theme.boxShadow1};
  border-radius: 11px;
  table{
    width: 100%;
    border:0;
    margin:0;
    border-collapse:collapse;
    border-spacing:0;
    font-size: 14px;
    font-weight: normal;
    position: relative;
    td {
      &:first-child{
        padding-left: 45px;
        ${({ theme }) => theme.mediaWidth.upToSmall`
          padding-left: 25px;
        `}
      }
    }
    thead{
      background: ${({ theme}) => theme.bsBg42};
      width: 100%;
      td{
        height: 32px;
        &:first-child{
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
        }
        &:last-child{
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
        }
      }
    }
    tbody{
      tr{
        /* border-bottom: 1px solid #F7E4CE; */
        td{
          height: 56px;
        }
      }
      .nothing{
        text-align: center;
        border-bottom: none;
        td {
          padding: 30px 0;
          height: auto;
          line-height: 0;
        }
      }
    }
  }
  ${({ theme }) => theme.mediaWidth.upToLarge`
    width: 100%;
  `}
`
const ListTable = styled.div`
  width: 409px;
  max-height: 280px;
  overflow-y: scroll;
  ${({ theme }) => theme.mediaWidth.upToLarge`
    margin: auto;
  `}
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
  `}
  .price {
    text-align: right;
  }
`
const AboutLink = styled(ExternalLink)`
  color: ${({ theme}) => theme.bsText38};
  font-weight: bold;
  text-decoration: none;
  font-family: Yuanti SC;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-left: 0;
    margin-right: 8px;
  `};
`

function dealToken (address: any) {
  if (address) {
    // return address.substring(0, 8) + '...' + address.substring(33)
    return address.substring(0, 4) + '...' + address.substring(38)
  }
  return '-'
}
export default function BiddingList ({type, tokenId, updateNum, tokenName}: {type?: string, tokenId?: string, updateNum?: number, tokenName?: string}) {
  const theme = useContext(ThemeContext)
  const list = useBidList(tokenId, type, tokenName)
  const emptyBids: any[] = []
  const [bidLists, setBidLists] = useState(emptyBids)
  const { chainId } = useActiveWeb3React()
  const bscLink = CONTRACT_ADDRESSES.bscApi[chainId as number]

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getList = useCallback(async () => {
    const bidList = await list()
    setBidLists(bidList)
  },[list])

  useEffect(() => {
    getList()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenId, updateNum, getList])

  return (
    <>
      <Box>
        <Text color={theme.bsText28} fontSize={20} fontFamily={'Roboto-Bold'} marginBottom={24}>Bidding</Text>
        <table>
          <thead>
            <tr>
              <td>
                <Text color={theme.bsText29}>Address</Text>
              </td>
              <td width={85}>
                <Text color={theme.bsText29}>Price</Text>
              </td>
            </tr>
          </thead>
        </table>
        <ListTable>
          <table>
            <tbody>
              {
                bidLists.length ? (
                  bidLists.map((d, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <Text color={theme.bsText38}>
                            <AboutLink href={`${bscLink}/address/${d.bidder}`}>
                              { dealToken(d.bidder) }
                            </AboutLink>
                          </Text>
                        </td>
                        <td width={140} className="price">
                          <Text color={theme.bsText38}>
                            <img src={'/images/bakery/icon_' + (tokenName || 'BAKE').toLocaleLowerCase() + '.svg'} width={19} height={19} style={{marginRight: '5px', marginBottom: '-5px'}} alt=""/>
                            {d.price}
                          </Text>
                        </td>
                      </tr>
                    )
                  })
                ) : (
                  <tr className={'nothing'}>
                    <td colSpan={2}>
                      <img src="/images/bakery/icon_nothing_bid.svg" alt=""/>
                      <Text color={theme.bsText38} fontSize={14} marginTop={'10px'}>No one is currently bidding here</Text>
                    </td>
                  </tr>
                )
              }
            </tbody>
          </table>
        </ListTable>
      </Box>
    </>
  )
}